import { find } from 'lodash'

import { WPPageData } from '@/types'

export const pageHasHero = (pageProps: WPPageData) => {
  const sections = pageProps?.acf?.builder || []
  return find(sections, (item) => item.acf_fc_layout.includes('hero')) !== undefined
}
